import React from 'react';
import './index.less';
import { Modal } from 'antd-mobile';

const preventEvent = (event) => {
  if (event) {
    event.preventDefault();
    event.stopImmediatePropagation && event.stopImmediatePropagation();
    event.stopPropagation();
  }
};

export default class ModalPage extends React.Component {

  static propTypes = {
  }

  state = {}



  render() {
    const { children, visible } = this.props;
    return (
      <Modal
        visible={visible}
        // animationType='fade'
        transitionName='aaa'
        maskClosable={false}
        className='modal-page'
        wrapClassName='ccc'
      >
        {children}
      </Modal>

    )
  }

}
